import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import styles from './modal-content-success.module.scss'
import successIcon from "../../../../../assets/order-summary-success.svg"

const SuccessModalContent = ({title, message, onClose}) => {

  return (
    <div className={styles['success']}>
      <Row>
        <Col lg={12}>
          <div>
            <h1>{title}</h1>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div>
            <img alt="Success" src={successIcon} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['message']}>
            <p>{message}</p>
          </div>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col lg={12}>
          <div className={styles['close-button']}>
            <Button variant="secondary" onClick={() => onClose()}>
              CLOSE
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default SuccessModalContent;
